module.exports = __webpack_public_path__ + "img/axis-realty-group-banner-5.007b3e8f.jpg";